import { makeAutoObservable, runInAction } from 'mobx'
import type { Notify } from '@/Ship/Contracts/Notify'
import { ConfirmAssignmentExecutionTask } from '../Tasks/ConfirmAssignmentExecutionTask'

/**
 * Local store of `ConfirmExecutionModal`.
 *
 * Confirms an assignment's execution. Dispatcher comment is required when the
 * task was not yet `completed_by_driver` (so-called "примусове підтвердження").
 */
export class ConfirmExecutionModalStore {
    open = false
    task: any = null
    comment = ''
    commentError: string | null = null
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    openFor(task: any): void {
        this.task = task
        this.comment = ''
        this.commentError = null
        this.loading = false
        this.open = true
    }

    close(): void {
        this.open = false
        this.task = null
        this.comment = ''
        this.commentError = null
        this.loading = false
    }

    setComment(v: string): void {
        this.comment = v
        if (v.trim()) this.commentError = null
    }

    /** Comment is required unless the task is already in `completed_by_driver`. */
    isCommentRequired(): boolean {
        return this.task?.status !== 'completed_by_driver'
    }

    async confirm(notify: Notify, reload?: () => void): Promise<boolean> {
        if (!this.task?.uuid) return false
        const trimmed = this.comment.trim()
        if (this.isCommentRequired() && !trimmed) {
            this.commentError = "Коментар диспетчера є обов'язковим"
            return false
        }
        this.loading = true
        try {
            await ConfirmAssignmentExecutionTask(this.task.uuid, trimmed || undefined)
            notify.success('Виконання підтверджено')
            reload?.()
            this.close()
            return true
        } catch (e: any) {
            notify.error(e?.message || 'Не вдалося підтвердити виконання')
            runInAction(() => { this.loading = false })
            return false
        }
    }
}
